import { render, staticRenderFns } from "./RC.vue?vue&type=template&id=1d20ad4a&scoped=true"
import script from "./RC.vue?vue&type=script&lang=js"
export * from "./RC.vue?vue&type=script&lang=js"
import style0 from "./RC.vue?vue&type=style&index=0&id=1d20ad4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20ad4a",
  null
  
)

export default component.exports